import cities from '../data/cities';
import regions from '../data/cityRegions';

// Builds all per-page content for a /locations/:citySlug page from the
// city + region data tables. Keeping this in one place is what lets us add
// a new city with a single data row instead of writing new copy each time.
export function getCityContent(citySlug) {
    const city = cities[citySlug];
    if (!city) return null;

    const region = regions[city.region];
    const { cityName, state, lat, lon } = city;

    return {
        cityName,
        state,
        lat,
        lon,
        description: `HomeButler brings the Home Operating System to ${cityName}, ${state}. Track every asset in your home, get AI-driven maintenance triage built for ${region.climateNote}, and connect with pros when you're ready to hire.`,
        seoTitle: `HomeButler in ${cityName}, ${state} | Home Maintenance Tracker & Digital Logbook`,
        seoDescription: `Manage home maintenance in ${cityName}, ${state} with HomeButler's Digital Asset Logbook, AI task triage, and Home Health Score. Built for ${region.label}'s ${region.climateNote}.`,
        commonNeeds: region.commonNeeds,
        faqSchema: {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
                {
                    '@type': 'Question',
                    name: `How much does it cost to replace an HVAC system in ${cityName}?`,
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: `In ${cityName}, ${state}, the average cost to replace an HVAC system ranges between ${region.hvacCostRange} depending on SEER rating, tonnage, and installation complexity.`,
                    },
                },
                {
                    '@type': 'Question',
                    name: `How much does it cost to replace a water heater in ${cityName}?`,
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: `In ${cityName}, ${state}, replacing a water heater typically costs between ${region.waterHeaterCostRange}, depending on whether it's a standard tank or tankless system.`,
                    },
                },
                {
                    '@type': 'Question',
                    name: `What are common home maintenance needs in ${cityName}?`,
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: `Homeowners in ${region.label} — including ${cityName} — should plan around ${region.seasonalAdvice}.`,
                    },
                },
            ],
        },
    };
}

export default getCityContent;
